import React from 'react';

import { Select } from '@mantine/core';
import { IconUsersGroup } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { TeamService } from 'services/team-service';
import { MEMBER_TEAMS_QUERY_KEY } from 'shared/constants/query-keys';

interface TeamSelectFilterProps {
  teamFilter: string;
  setTeamFilter: (value: string) => void;
  myFilter: string;
}

export function TeamSelectFilter({ teamFilter, setTeamFilter, myFilter }: TeamSelectFilterProps) {
  const memberTeamsQuery = useQuery({
    queryKey: [MEMBER_TEAMS_QUERY_KEY],
    queryFn: TeamService.getMemberTeams
  });

  // Query helpers
  const teams = memberTeamsQuery.data?.map((team) => team.name) ?? [];
  const teamFilters = [myFilter, ...teams];

  return (
    <Select
      value={teamFilter}
      onChange={(value) => value && setTeamFilter(value)}
      style={{ width: 210 }}
      data={teamFilters}
      size="sm"
      icon={<IconUsersGroup size={18} />}
      styles={{
        input: {
          textOverflow: 'ellipsis'
        }
      }}
    />
  );
}
